import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "normalize.css";
import "./plugins/element.js";
import "./plugins/axios";
import "@/styles/index.scss"; // global css
import "@/assets/fontIcon/iconfont.css";
import api from "@/utils/ajax";
import apiConfig from "@/api";
import tracer from "./plugins/mc-tracer"; //埋点
import moment from "moment";
tracer();
Vue.config.productionTip = false;
api.load(apiConfig);

import urlPath from "@/directive/url-path";

urlPath.install(Vue);

//定义一个全局过滤器实现日期格式化
Vue.filter("datefmt", function(input, fmtstring) {
  // 使用momentjs这个日期格式化类库实现日期的格式化功能
  return moment(input).format(fmtstring);
});

router.beforeEach((to, from, next) => {
  if (!Vue.prototype || !Vue.prototype.$concatPhone) {
    const paramsArr = [
      {
        biz_code: 100,
        position: 1
      },
      {
        biz_code: 100,
        position: 2
      },
      {
        biz_code: 310
      }
    ];

    const getConcatPhonePromise = paramsArr.map(params =>
      _api.all.getConcatPhone(params)
    );
    Promise.all(getConcatPhonePromise).then(phoneValues => {
      console.log("phoneValues", phoneValues);
      if (phoneValues[0] && phoneValues[0].code == 200) {
        // 400
        Vue.prototype.$concatPhone = phoneValues[0].data.phone;
        // 400-0
        Vue.prototype.$concatPhoneZero = phoneValues[1].data.phone;
        // 县域
        Vue.prototype.$zeroOneZeroPhone = phoneValues[2].data.phone;
      }
      next();
    })
    .catch(()=>{
      next();
    });
  } else {
    next();
  }
});
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
